//  here you can find Full list of AdEvent -  https://github.com/alugha/typed-ima-sdk/blob/master/src/ima.d.ts#L444
export enum AdEvent {
	COMPLETE = 'complete',
	ALL_ADS_COMPLETED = 'allAdsCompleted',
	STARTED = 'start',
}
